module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Savage-Kingdom-S3.68e80fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Savage-Kingdom-S3.jpg
// module id = 8EVB
// module chunks = 0